<app-moveable-panel>
  <div class="flex flex-col">
    <app-movable-panel-title>
      <div class="grow flex items-center justify-between gap-4">
        <span>{{ 'multi-site-dashboard.vehicle-state-of-charge-summary.title' | translate }}</span>
        <div class="flex items-center gap-2">
          <app-multi-select type="single" [options]="rangeOptions()" [ngModel]="range()" (ngModelChange)="onRangeChange($event)" />
          <ng-content></ng-content>
        </div>
      </div>
    </app-movable-panel-title>

    @if (isLoading()) {
      <app-vehicle-state-of-charge-summary-movable-panel-loading-skeleton />
    } @else if (vm()) {
      @let viewModel = vm()!;
      <div class="flex flex-col gap-2 px-2">
        <!-- Header: empty site-name spacer + one date label per day column. -->
        <div class="flex">
          <div class="shrink-0 w-[190px]"></div>
          <div class="grow grid" [style.gridTemplateColumns]="'repeat(' + viewModel.days.length + ', minmax(0, 1fr))'">
            @for (day of viewModel.days; track day) {
              <div
                class="flex justify-center text-sm font-semibold text-foreground-primary-60 px-2 pb-2 border-b border-foreground-primary-20 relative"
              >
                <div class="w-[1px] h-[7px] bg-foreground-primary-20 absolute bottom-0 left-0"></div>
                <app-site-date-time [value]="day" format="dayNameDate" />
              </div>
            }
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <!-- One row per site: site name + a charged/issue cell per day. -->
          @for (site of viewModel.sites; track site.siteId) {
            <div class="flex items-stretch bg-background-container-primary rounded-radius-container">
              <div class="shrink-0 w-[190px] flex items-center px-4 py-3 font-semibold">{{ site.siteName }}</div>
              <div class="grow grid" [style.gridTemplateColumns]="'repeat(' + viewModel.days.length + ', minmax(0, 1fr))'">
                @for (cell of site.cells; let first = $first; track cell.date) {
                  <div class="flex flex-col py-4">
                    <div
                      class="grow flex flex-col items-center px-1 min-h-[36px]"
                      [ngClass]="[!first ? 'border-l border-stroke-primary-8' : '']"
                    >
                      <div class="flex flex-wrap items-center gap-2 text-2xl font-semibold">
                        <span class="flex items-center text-foreground-primary-80">
                          {{ cell.fullyChargedCount }}
                          <svg-icon key="ready-v-2-24" size="24" class="text-status-success"></svg-icon>
                        </span>

                        <span class="flex items-center text-status-error min-w-[30px]">
                          @if (cell.notFullyChargedCount > 0) {
                            {{ cell.notFullyChargedCount }}
                            <svg-icon key="faulted-v-2-24" size="24" class="text-status-error"></svg-icon>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Legend: charged / issue keys, mirroring the energy & cost overview card. -->
      <div class="flex flex-col px-2 pt-4">
        <div class="flex flex-wrap items-center pb-2 gap-x-6 gap-y-1 border-b border-stroke-primary-8 text-xs text-foreground-primary-60">
          <div class="flex items-center gap-2">
            <svg-icon key="ready-v-2-24" size="24" class="text-status-success"></svg-icon>
            <span>{{ 'multi-site-dashboard.vehicle-state-of-charge-summary.charged' | translate }}</span>
          </div>
          <div class="flex items-center gap-[6px]">
            <svg-icon key="faulted-v-2-24" size="24" class="text-status-error"></svg-icon>
            <span>{{ 'multi-site-dashboard.vehicle-state-of-charge-summary.issue-not-fully-charged' | translate }}</span>
          </div>
        </div>
      </div>
    }

    <div class="flex items-center justify-end p-4">
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites]">
        <app-panel-link [label]="'multi-site-dashboard.view-sites' | translate"></app-panel-link>
      </a>
    </div>
  </div>
</app-moveable-panel>
